const MOBILE_DEVICE_REGEXP = /Android|iPhone|iPad/i;

const { matches: is767PxOrLess } = window.matchMedia("(max-width: 767px)");

export const isMobile = (): boolean =>
	MOBILE_DEVICE_REGEXP.test(navigator.userAgent) && is767PxOrLess;
